const PAGE_SIZE = 24;

export const getDraftsQueryOptions = (_: {}) => ({
	variables: {
		cqlcontext: `{"contentStatuses":["draft"]}`,
		first: PAGE_SIZE,
	},
});
